(function () {
  const formatMoney = (cents) => {
    const v = (cents / 100).toFixed(2);
    return `$${v.replace(/\.00$/, '')}`;
  };

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    return res.json();
  }

  function isEnabledFor(el) {
    if (el?.dataset?.enabled !== undefined) {
      return String(el.dataset.enabled).toLowerCase() === 'true';
    }
    if (window.themeSettings && 'free_shipping_enabled' in window.themeSettings) {
      return !!window.themeSettings.free_shipping_enabled;
    }
    return true;
  }

  function getThresholdFor(el) {
    if (el?.dataset?.threshold) {
      const v = parseInt(el.dataset.threshold, 10);
      return Number.isFinite(v) ? v : 0;
    }
    const usd = (window.themeSettings?.free_shipping_threshold) || '0';
    const num = parseFloat(String(usd).replace(/[^\d.]/g, '')) || 0;
    return Math.round(num * 100);
  }

  function updateBlocks(cart) {
    const blocks = document.querySelectorAll('.free-ship-msg');
    if (!blocks.length) return;

    blocks.forEach((el) => {
      const enabled = isEnabledFor(el);
      if (!enabled) {
        el.setAttribute('hidden', 'hidden');
        return;
      } else {
        el.removeAttribute('hidden');
      }

      const threshold = getThresholdFor(el);
      const subtotal = cart.items_subtotal_price || 0;
      const remaining = Math.max(threshold - subtotal, 0);
      const unlocked = threshold > 0 && remaining === 0;

      const fill = el.querySelector('.free-ship-bar__fill');
      if (fill) {
        const progress = threshold > 0 ? Math.min(100, Math.floor((subtotal * 100) / threshold)) : 0;
        fill.style.width = `${progress}%`;
      }

      const p = el.querySelector('.free-ship-text');
      if (p) {
        p.setAttribute('data-unlocked', unlocked ? 'true' : 'false');
        const unlockedLabel = (window.themeSettings?.free_shipping_label_unlocked) || '🎉 You unlocked FREE shipping';
        const baseLabel = (window.themeSettings?.free_shipping_label) || "You're only remaining away from FREE shipping";
        if (threshold <= 0) {
          p.textContent = '';
        } else {
          p.textContent = unlocked ? unlockedLabel : baseLabel.replace('remaining', formatMoney(remaining));
        }
      }
    });
  }

  async function refreshFreeShip() {
    try {
      const cart = await fetchCart();
      updateBlocks(cart);
    } catch (e) {
      console.warn('FreeShip refresh error', e);
    }
  }

  window.refreshFreeShip = refreshFreeShip;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshFreeShip);
  } else {
    refreshFreeShip();
  }

  ['cart:updated','cart:update','cart:change','ajaxProduct:added'].forEach(evt =>
    document.addEventListener(evt, refreshFreeShip)
  );

  const origFetch = window.fetch;
  window.fetch = async function(input, init) {
    const res = await origFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : (input?.url || '');
      if (url.includes('/cart/add')) {
        Promise.resolve().then(() => refreshFreeShip());
      }
    } catch {}
    return res;
  };

  let kickTimer;
  const kick = () => {
    clearTimeout(kickTimer);
    kickTimer = setTimeout(refreshFreeShip, 800);
  };
  ['click','change'].forEach(evt => document.addEventListener(evt, kick, { capture: true }));
})();
